export const STAMINA = "stamina";

export const WANDER_STA_COST = 5;
export const MEDITATE_STA_COST = -10;


// WEBPACK FOOTER //
// ./src/data/constants/resources.ts